import { getRepubMetaFromRepub, isValidRepub } from '@cx-web/utils';

import { REPUBS } from '@cx-modules/constants';

export function getPathAndRepubFromUrlPath(urlPath: string) {
  const firstSegment = urlPath.split('/')[1]?.toUpperCase();
  if (!isValidRepub(firstSegment) || !REPUBS[firstSegment]) {
    return { repub: REPUBS.OC.name, path: urlPath };
  }

  const repub = REPUBS[firstSegment] ? firstSegment : REPUBS.OC.name;
  const { repubIs } = getRepubMetaFromRepub(repub);

  const pathWithoutRepub = `/${urlPath.split('/').slice(2).join('/')}`;
  const path = repubIs.OC ? urlPath : pathWithoutRepub;

  return {
    repub,
    path,
  };
}
